{
  "acceptInvitation": "Accept it",
  "email": "Email",
  "forgotPassword": "Forgot your password?",
  "haveInvitation": "Have an invitation?",
  "noAccount": "No account yet?",
  "password": "Password",
  "pleaseWait": "Please wait…",
  "register": "Create one",
  "sessionEnded": "Your session has ended. Please sign in again.",
  "setupOpenAction": "Set up the first administrator",
  "setupOpenMessage": "Whoever installed DMW sets up the first administrator with the setup token from the server's configuration.",
  "setupOpenTitle": "This installation has no administrator yet",
  "submit": "Sign in",
  "title": "Sign in"
}
